import { Chain, createClient } from 'viem';
import { Config, createConfig, http } from 'wagmi';
import { WagmiConfigParams } from '../types';

/**
 * Creates client required for wagmi context
 */
export function getWagmiConfig(params: WagmiConfigParams): Config {
  return createConfig({
    chains: params.supportedChains as unknown as readonly [Chain, ...Chain[]],
    connectors: params.connectors,
    client({ chain }) {
      return createClient({
        chain,
        transport: http(getChainRpcUrl(chain)),
      });
    },
    ssr: true,
  });
}

function getChainRpcUrl(chain: Chain): string | undefined {
  return chain.rpcUrls.default.http[0] ?? chain.rpcUrls.public?.http[0];
}
